<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween } from 'gsap'
import TransitionWrapper from '@/layout/wrappers/transition-wrapper'

export default {

  name: 'TheLoader',

  components: {
    TransitionWrapper
  },

  methods: {

    enter (el, done) {
      Tween.from(el, 1, {
        autoAlpha: 0,
        onComplete: done
      })
    },

    leave (el, done) {
      Tween.to(el, 1, {
        autoAlpha: 0,
        onComplete: done
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.loader
  .loader__background
  .loader__content
    span.spinner
    transition-wrapper(name="fade")
    transition(name="fade")
      span.label(v-if="this.$t('load') !== 'load'") {{ $t('load') }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter{
  opacity: 0;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

.loader
  position fixed
  top 0
  left 0
  width 100%
  height 100%

  &__background
    z-index 1
    position absolute
    top 0
    left 0
    width 100%
    height 100%

  &__content
    z-index 2
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    display flex
    flex-direction column
    justify-content center
    align-items center

.spinner
  display block
  width 50px
  height 50px
  margin 50px
  border 5px solid transparent
  border-top-color orange
  border-bottom-color orange
  border-radius 50%
  animation spinner .8s ease-in-out infinite

@keyframes spinner
  from
    transform rotate(0deg)
  to
    transform rotate(360deg)

.label
  font-weight 400
  font-size 24px
  line-height 34px
  text-align center
  user-select none

  +mobile()
    font-size 14px
    line-height 20px

</style>



// WEBPACK FOOTER //
// the-loader.vue?d3120c5e